/**
 * A layout level.
 *
 * -- Props --
 * | Name       | Type    | Required  | Default Value | Description
 * |------------|---------|-----------|---------------|---------------
 * | id         | string  | false     | null          | An id to apply to this component.
 * | className  | string  | false     | ""            | Additional classes to apply to this component.
 */
export const Level = (props) => {
  return (
    <nav id={props.id || null} className={`level${props.className ? " " + props.className : ""}`}>
      {props.children}
    </nav>
  );
}

export default Level;
